import Header from "../../components/Account/HeaderImage";
import Footer from "../../components/Account/Footer";
import React, { useEffect, useRef, useState, useContext, useMemo } from 'react';
import { auth0Cred } from "../auth0Cred";
import { useForm } from 'react-hook-form';
import { $CommonServiceFn, $postServiceFn } from '../../components/network/Service';
import { $Service_Url } from '../../components/network/UrlPath';
import Captcha from "../../components/Account/reCaptcha/Captcha";
import { NavLink, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import konsole from "../../components/control/Konsole";
import { UserContext } from "../../App";
import commonLib from "../../components/control/commonLib";
import Success from "../../components/Account/Success";
import HeaderImage from "../../components/Account/HeaderImage";
import { errorMsg } from "../../components/control/Constant";
import CommonInputContainer from "../../components/CommonInputContainer";
import SessionTimeout from "../../components/SessionTimeout";


const SignIn = (props) => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  const [passwordType, setPasswordType] = useState('password');
  const { register, handleSubmit, watch, setError, setValue, clearErrors, formState: { errors } } = useForm();
  const { setLoader, setcurMainImageNum, setWarning } = useContext(UserContext);
  const captchaRef = useRef(null);

  const [userNameFromCookies, setUserNameFromCookies] = useState("");
  const [rememberUserNameStatus, setRememberUserNameStatus] = useState(false);
  const [rolesDetails, setRolesDetails] = useState([]);
  const [checkforgetPassstatus, setcheckforgetPassstatus] = useState(false);
  const [sendforgetpassmail, setsendforgetpassmail] = useState("");
  const [upcomingScreenType, setUpcomingScreenType] = useState("");
  const [upcomingScreenSubtenant, setUpcomingScreenSubtenant] = useState("");
  const [subtenantId, setSubtenantId] = useState("");
  const [loginSuccess, setloginSuccess] = useState(false);
  const [showTimeoutModal, setShowTimeoutModal] = useState(false);

  const startingTabIndex = props?.startTabIndex ?? 0;


  const type = commonLib.getQueryFromUrl("type")
  const sessionTimeout = commonLib.getQueryFromUrl("expired")

  // console.log(subtenantId,"subtenantIdsubtenantId");

  const subtenantDetails = commonLib.getSessionStorage("subtenantDetails");
  const userInvalidErrMsg = "The username or password you entered is incorrect. Please try again.";

  useEffect(() => {
    sessionStorage.removeItem("AuthToken");
    if (sessionTimeout) {
      setShowTimeoutModal(true);
    }
    let subtenantId = commonLib.getQueryFromUrl("subtenantId");
    if (subtenantId) {
      setSubtenantId(subtenantId);
    }
    else if (subtenantDetails !== null) {
      setSubtenantId(JSON.parse(subtenantDetails).subtenantId)
    }
    else {
      setSubtenantId(null);
    }

    if (state !== null) {
      setUpcomingScreenType(state?.type);
      setUpcomingScreenSubtenant(state?.subtenantId);
    }
  }, [sessionTimeout, state, subtenantDetails])


  // use Location handle --------------------------------------------------------------------------
  useEffect(() => {
    let rememberData = localStorage.getItem("userName")
    if (rememberData !== null && rememberData !== undefined && rememberData !== "") {
      konsole.log("rememberDatarememberData", rememberData)

      setValue("email", decodeURIComponent(rememberData))
      setUserNameFromCookies(setValue)
      // setRememberUserNameStatus1(true)
      setRememberUserNameStatus(true)
    }

    setcurMainImageNum(1);

  }, []);



  const isStaffLogin = useMemo(() => {
    let isStaff = window.location.pathname?.includes('legal-staff') || window.location.pathname?.includes('legal-staff');
    return isStaff;
  }, [window.location.pathname]);



  const onSubmit = async (data) => {
    if (isValidate(data) === true) {
      return;
    }
    setLoader(true);

    localStorage.setItem("|/*P*/|", window.btoa(commonLib?.passwordformatAndReverse(data?.password))
    );

    if (rememberUserNameStatus === true) {
      localStorage.setItem("userName", encodeURIComponent(data.emailId));
    }

    // $CommonServiceFn.InvokeCommonApi("GET", $Service_Url.checkLoginUserExist + data.emailId, "",

    $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.checkLoginUserExist,
      {
        UserName : data.emailId
      },




      async (resp, error) => {
        if (error) {
          setLoader(false);
          if (error?.data?.data === false) {
            setError("invalidUser", {
              type: "custom",
              message: userInvalidErrMsg
            });

          } else {

            setWarning(
              "warning",
              errorMsg.somethingErr
            );
          }

          return;
        }

        if (resp && resp.status === 200 && resp.data?.data === true) {


          const payload = {
            username: data.emailId,
            password: data.password
          };
          $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.loginUser, payload, (response, loginError) => {
            if (loginError) {
              setLoader(false);
              if (loginError?.status === 400 || loginError?.status === 401) {
                setError("invalidUser", {
                  type: "custom",
                  message: userInvalidErrMsg
                });
              } else {
                setError("invalidUser", {
                  type: "custom",
                  message: errorMsg.somethingErr
                });
              }

              return;
            }

            if (response?.status === 200 && response?.data?.succeeded === true && (response?.data?.data?.accessToken || response?.data?.data?.access_token)) {
              const loginData = response.data.data;
              commonLib.setSessionStorage("AuthToken", (loginData.accessToken || loginData.access_token));
              // commonLib.setSessionStorage("LoginAuthResult",JSON.stringify(loginData));
              // commonLib.setSessionStorage("LoginEmail",data.emailId);
              setLoader(false);

              navigate(isStaffLogin ? "/legal-staff/Redirect" : "/Account/Redirect",
                {
                  replace: true,
                  state: {
                    email: data.emailId,
                    expiresIn: loginData.expiresIn || loginData?.expires_in
                  }
                }
              );

              return;
            }

            setLoader(false);

            setError("invalidUser", {
              type: "custom",
              message: userInvalidErrMsg
            });
          }
          );
          return;
        }

        setLoader(false);
        setError("invalidUser", {
          type: "custom",
          message: userInvalidErrMsg
        });
      }
    );
  };

  const passwordToggle = () => {
    if (passwordType === 'password') {
      setPasswordType('text')
    }
    else {
      setPasswordType('password')
    }
  };


  const handleWrongPass = (e) => {
    clearErrors('invalidUser');
    e.target.value = e.target.value.trimStart();
  }
  const rememberUserName = (e) => {
    setRememberUserNameStatus(e.target.checked)
    // setRememberUserNameStatus1(e.target.checked)
  }

  const handleOnBlur = (e) => {
    let value = e.target.value

    if (value == "" || !commonLib.isEmailRegEx(value)) {
      return;
    }




    konsole.log("value", value)
    setLoader(true)
    // $CommonServiceFn.InvokeCommonApi("GET", $Service_Url.getUserDetailsByEmailId + `?emailId=${value}`, "",

    $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.getUserDetailsByEmailId,
      {
        emailId: value
      },








      (res, err) => {
        setLoader(false)
        if (res) {
          konsole.log("getUserDetailsByEmailId", res)
          let responseData = res?.data[0];
          let rolesDetails = responseData?.roleDetails;

          setRolesDetails(rolesDetails)
          let checkroleAcademy = rolesDetails?.some(item => item?.roleId === 17)
          let checkRoleLagecy = rolesDetails?.some(item => item?.roleId === 20)
          konsole.log("responseData", responseData, rolesDetails, checkroleAcademy)

          if (checkroleAcademy == true && responseData?.auth0Id == null) {
            setError('invalidUser', { type: "custom", message: "Please activate your account before signing in." })
            let userId = responseData?.userId
            let jsonobj = {
              "userRegstrtnId": responseData?.id,
              "userId": userId,
              "signUpPlatform": responseData?.signUpPlatform,
              "createdBy": userId
            }
            userActivationLinkfun(jsonobj)
          } else if (checkRoleLagecy == true && responseData?.auth0Id !== null && responseData?.isPwdAvailable !== true) {
            resetPassword(value)
          }
        } else {
          konsole.log("getUserDetailsByEmailId", err)
        }
      })
  }

  const resetPassword = (emailId) => {
    setsendforgetpassmail(emailId)
    setLoader(true)
    const jsonobj = {
      userName: emailId,
      emailID: emailId,
      requestedIP: "::1",
      commMedium: "Email",
      commSendOn: emailId
    }
    konsole.log("jsonobjjsonobj", JSON.stringify(jsonobj))
    $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.postForgotPassword, jsonobj, (response, errData) => {
      if (response) {
        setLoader(false)
        setcheckforgetPassstatus(true)
        konsole.log("postForgotPassword", response)
      }
      else {
        setLoader(false)
        konsole.log("postForgotPassword", errData)
      }
    });

  }

  const userActivationLinkfun = (jsonobj) => {
    konsole.log("jsonobjjsonobj", JSON.stringify(jsonobj))
    setLoader(true)
    $CommonServiceFn.InvokeCommonApi("POST", $Service_Url.getUserActivationLink, jsonobj, (res, err) => {
      setLoader(false)
      if (res) {
        konsole.log("getUserActivationLink", res)
        let responseData = res.data.data
        konsole.log("responseData", responseData, responseData?.activationURL)
        window.location.replace(responseData?.activationURL)

      } else {
        konsole.log("getUserActivationLink", err)
      }
    })
  }

  //handle register btn----------------------------------------------------------------
  const handleRegisterHere = () => {
    let subtenantIdLocal = upcomingScreenSubtenant ? upcomingScreenSubtenant : subtenantId
    if (subtenantIdLocal == 3) {
      navigate(`/Account/startfreetrial?subtenantId=${subtenantId}`)
    } else {
      navigate('/Account/Signup')
    }
  }


  const showCaptchaError = () => {
    let captchaValue = captchaRef.current?.checkCaptcha();
  }
  const inputfieldcapital = (val) => {

    val.target.value = val.target.value?.trimStart();
  }

  const isValidate = (formData) => {
    let isAnyError = false;
    const { emailId, password, } = formData;

    if (!emailId) {
      setError("emailId", { type: "error", message: errorMsg.emailId.empty })
      isAnyError = true
    } else if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailId) == false) {
      setError("emailId", { type: "error", message: errorMsg.emailId.invalid })
      isAnyError = true
    }

    if (!password) {
      setError("password", { type: "error", message: errorMsg.password.empty })
      isAnyError = true
    }
    return isAnyError;
  }

  const ErrorShower = ({ inputName }) => {
    konsole.log(inputName, "inputName")
    return errors?.[inputName]?.message ? <p className='attention'>{errors?.[inputName]?.message}</p> : "";
  }
  konsole.log(errors, "errorserrorserrorserrors")
  //handle register btn----------------------------------------------------------------

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column flex-grow-1 justify-content-center align-items-center" >
   {/* <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column flex-grow-1 align-items-center" style={{justifyContent:"space-between", minHeight:"100%"}}> */}
    <div id='logIn' >
      <div className='headerImg'>
        <HeaderImage />
      </div>

        <div className="mt-4">
          <div className="parentDiv">
            <p className='title text-center'>{isStaffLogin ? "Staff Payment Login" : "Login"}</p>
            <p className='sub-title text-center'>Welcome back! Please Enter Your Details</p>

            {errors?.invalidUser ? <p className='attention mb-4'>{errors?.invalidUser?.message}</p> : ""}
            {loginSuccess ? <p className='attention mb-4 text-success'>{"Login successful. Welcome back to Aging Options Portal!"}</p> : ""}
            <CommonInputContainer
              label="Email*"
              error={errors?.emailId}
            >
              <input tabIndex={startingTabIndex + 1} className={`w-100 ${errors?.emailId ? 'input-error' : ''}`} type='email' placeholder='Enter Email' onInput={handleWrongPass}
                {...register("emailId", {
                  onChange: (e) => { inputfieldcapital(e) }
                })} />
            </CommonInputContainer>

            <CommonInputContainer
              label="Password*"
              error={errors?.password}
            >
              <input tabIndex={startingTabIndex + 2} style={{ paddingRight: "50px" }} type={passwordType} placeholder='Enter Password' className={`w-100  ${errors?.password ? 'input-error' : ''}`} onInput={handleWrongPass}
                {...register('password', {
                  onChange: (e) => { inputfieldcapital(e) }
                })}
              />
              <img
                src={(passwordType === 'password') ? '/icons/eye-off.svg' : '/icons/eye-show.svg'}
                className={`toggle-icon img-fluid cursor-pointer ${errors?.password ? 'error' : ''}`}
                onClick={passwordToggle}
                alt='toggle visibility'
              />
            </CommonInputContainer>

            <div className="label-input">
              <button tabIndex={startingTabIndex + 3} className='singUpBtn border-0' type="submit">Login</button>
            </div>

        <div  className="other-links">
          <NavLink tabIndex={startingTabIndex +  4} className="aTagElement" to="/Account/ForgetPassword">Forgot Password?</NavLink>
          {(isStaffLogin) ? <></> : <p>Don't have an account ? <NavLink tabIndex={startingTabIndex +  5} className="aTagElement" to="/Account/Signup#">Sign Up</NavLink></p>}
        </div>
        </div>
      </div>
    </div>
    {showTimeoutModal && <SessionTimeout setShowTimeoutModal={setShowTimeoutModal} />}
    {[1020, 1042, 1043, 1044]?.includes(Number(subtenantId)) && 
    <p className="text-center mb-3" style={{position:"fixed", bottom:"0", width:"100%"}}>Powered by <span style={{color:"#720C20", fontWeight:"600"}}>AgingOptions</span></p>}
    </form>
  );
};

export default SignIn;